import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, PUBLIC, PUBLIC_JOBS } from "../../common/URLs";


const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${PUBLIC_JOBS}`; 

export const fetchPublicJobList = async (page) => {
  const url = `${API_BASE_URL}?page=${page}`; 
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    // console.log("error", error);
    const errorMessage = error.message;
  }
};